module.exports = __webpack_public_path__ + "static/media/mill.e8acc6bd.svg";